export interface GridViewModel<T> {
    records: number;
    data: T;
}